import React from 'react'
import { Heading, Flex, Box } from 'rebass'
import styled from 'styled-components'
import typography from '../../../utils/typography'
import ContentArticleCards from '../../../components/ContentArticleCards'
import { lazyload } from '../../../utils/style'
import LazyLoad from 'react-lazyload'

const FlexWrapper = styled(Flex)`
  align-items: center;
  justify-content: center;
  flex-direction: column;
  overflow: hidden;
`

const LatestArticlesWidget = ({ container: Container, latestArticles }) => {
  return (
    <Container>
      <FlexWrapper mb={typography.rhythm(1)}>
        <Box mb={[typography.rhythm(1), typography.rhythm(1.5)]} px={20}>
          <Heading id="h4" fontSize={[7, 7, 8]} center>
            Latest articles from Citygate
          </Heading>
        </Box>
        <LazyLoad offset={lazyload.offset} height={260} once>
          <ContentArticleCards articles={latestArticles} />
        </LazyLoad>
      </FlexWrapper>
    </Container>
  )
}

export default LatestArticlesWidget
